export default function FamilyConnect() {
  return (
    <div style={{minHeight:'100vh',background:'#0F172A',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'24px'}}>
      <h1 style={{color:'#F1F5F9',fontSize:'1.5rem',fontWeight:'800',marginBottom:'12px',textAlign:'center'}}>Connect with Your Senior</h1>
      <p style={{color:'#94A3B8',marginBottom:'32px',textAlign:'center'}}>Enter the invite code shared by your loved one</p>
      <input placeholder="Enter invite code" style={{
        background:'#1E293B',
        border:'2px solid #334155',
        borderRadius:'8px',
        padding:'14px 20px',
        color:'#F1F5F9',
        fontSize:'1.2rem',
        textAlign:'center',
        letterSpacing:'0.3em',
        width:'100%',
        maxWidth:'280px'
      }} />
      <button style={{
        marginTop:'16px',
        background:'#38BDF8',
        color:'#0F172A',
        border:'none',
        borderRadius:'8px',
        padding:'14px 40px',
        fontWeight:'700',
        fontSize:'1rem',
        cursor:'pointer'
      }}>Connect</button>
    </div>
  );
      }
